<div id="head">Select chart type to print</div><hr>
<div id="btn1" (click)="selectedvac('allvac')">All Vaccinations</div><hr>
<div id="btn2" (click)="selectedvac('givenvac')">Given Vaccinations only</div><hr>
<div id="btn3" (click)="selectedvac('duevac')">Due Vaccinations only</div><hr>
<div id="cancel" (click)="Close()">Cancel</div>
